import React, { Component } from 'react';
import { connect } from 'react-redux';

import Analytics from 'APP_ROOT/services/analytics';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import MainModuleGroup from 'APP_ROOT/components/LayoutTemplateModularFullscreen/MainModuleGroup';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import Events from 'APP_ROOT/components/common/events';
import NotFoundPage from 'APP_ROOT/components/pages/notFoundPage';
import { addAllMedia } from 'APP_ROOT/data/media/actions';
import { addAllEventsAndLinkMedia, requestImageUrlsForEventIfNeeded } from 'APP_ROOT/data/events/actions';
import SettingsSelectors from 'APP_ROOT/data/settings/selectors';
import { loadSettings } from 'APP_ROOT/data/settings/actions';
import geofences from 'APP_ROOT/data/geofences';
import { Selectors as tagsSelectors, DispatchHelpers as tagsActions } from 'APP_ROOT/data/tags';
import { ACTIONS as layoutTemplateModularFullscreenDispatchActions, ACTIVE_MENU_ITEM_IDS } from 'APP_ROOT/data/layoutTemplateModularFullscreen/duck';

import CardSelectPanel from './CardSelectPanel';
import CardDetailsPanel from './CardDetailsPanel';
import EnhancedVideoAccess from '../../components/pages/dashboard/EnhancedVideoAccess/EnhancedVideoAccess';
import CardMapPanel from './CardMapPanel';
import CardHeader from './CardHeader';
import Permissions from '../../data/permissions';

import { fetchDemoCard, fetchDemoCards } from './demoApi';

const DEFAULT_UOM = 'IMPERIAL';

export const HISTORY_SELECTED_RESOURCE_TYPES = {
    HISTORY_CARD_PLACEHOLDER: "history_card_placeholder", // on load, if nothing selected yet
    HISTORY_CARD_DRIVING: "history_card_driving",
    HISTORY_CARD_PARKED: "history_card_parked"
}

// append 'Z' to all timestamps bc kloud won't
const markTimestampUTC = obj => {
    if(obj && obj.ts && !obj.ts.endsWith('Z')) {
        obj.ts = obj.ts + 'Z';
    }
};

const markTimestampUTCForKeys = (obj, keys) => {
    if(!obj) return;
    keys.forEach(k => {
        if(obj[k] && typeof(obj[k]) === 'string' && !obj[k].endsWith('Z')) {
            obj[k] = obj[k] + 'Z';
        }
    });
};



// ravenUuid and cardId provided by path params
// cards from LambdaUtil
//  loaded in componentDidMount (unless ravenUuid is undefined) and in componentDidUpdate when ravenUuid changes
// card from lambdaUtil
//  loaded when cardId changes (unless undefined)
//  set to null when cardId becomes null
export class HistoryPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            cards: null,
            requestedCardId: undefined, // used during lambda query callback to determine if the requested and selected cards still match
            loadingNewCard: false, // used to differentiate a refreshing the current card (adding new events, media) or full reload of card details in the Details panel and map
            card: null,
            selectedEvent: null,
            ravenOffline: undefined, // "undefined" will trigger vehicleState check
            enhancedVideoAccessModeActive: false
        };
        this.vehicleStateLoading =  false; // not using state, avoiding re-renders for this minor detail (re: ravenOffline)
        this.componentIsMounted = true; // avoid state updates when componentWillUnmount (halt setState during setCards callback)
    }

    componentDidMount() {
        Analytics.pageView();

        if (!this.props.ravens) {
            this.props.getUserData(this.onUserDataLoaded);
        } else {
            this.onUserDataLoaded();
        }
        document.addEventListener(Events.REFRESH_MEDIA, this.onRefreshMediaEvent);
    }

    componentWillUnmount() {
        this.componentIsMounted = false;
        document.removeEventListener(Events.REFRESH_MEDIA, this.onRefreshMediaEvent);
    }

    onRefreshMediaEvent = () => {
        const { ravenUuid, cardId } = this.props.match.params;
        if (ravenUuid && cardId) {
            this.loadDetailedCard(ravenUuid, cardId);
        }
    }

    toggleEnhancedVideoAccessModeActive = () => {
        const isActive = !this.state.enhancedVideoAccessModeActive;
        this.setState({
            enhancedVideoAccessModeActive: isActive
        })
        if (!isActive) {
            const { ravenUuid } = this.props.match.params;
            Events.enhancedVideoAccessRouteHighlightRequest(ravenUuid, 0, 0); // <-- clear any current highlight
        }
    }

    onUserDataLoaded = () => {

        this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.HISTORY_TRIP_REVIEW);

        const { ravenUuid, cardId } = this.props.match.params;
        if(this.checkRavenUuid(ravenUuid)) {
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            this.loadCards(ravenUuid);
            if(cardId) {
                this.loadDetailedCard(ravenUuid, cardId);
            }
        }

        if (!this.props.settingsLoaded) {
            this.props.loadSettings();
        }
    }

    checkRavenUuid = ravenUuid => {
        if(!ravenUuid) {
            const { selectedRaven, ravens } = this.props;
            if(selectedRaven) {
                this.selectRaven(selectedRaven.ravenUuid);
            } else if (ravens && ravens[0]) {
                this.selectRaven(ravens[0].ravenUuid);
            }
            return false;
        }
        return true;
    }

    componentDidUpdate(prevProps) {
        const { ravenUuid, cardId } = this.props.match.params;

        // confirm selected raven
        if(this.checkRavenUuid(ravenUuid)) {

            // switching ravens:
            if(ravenUuid !== prevProps.match.params.ravenUuid) {
                if (this.state.enhancedVideoAccessModeActive) {
                    this.toggleEnhancedVideoAccessModeActive();
                }
                this.loadCards(ravenUuid);
                return; // set state above triggers a subsequent componentDidUpdate which should continue to the if-condition below
            }

            // switching cards:
            if (cardId && (cardId !== prevProps.match.params.cardId)) {
                if (this.state.enhancedVideoAccessModeActive) {
                    this.toggleEnhancedVideoAccessModeActive();
                }
                this.loadDetailedCard(ravenUuid, cardId);
            }

            // checking raven offline state if not set for this raven yet:
            if (this.state.ravenOffline === undefined) {
                const { ravens } = this.props;
                const selectedRaven = ravens ? ravens.find(r => r.ravenUuid === ravenUuid) : undefined;
                if (selectedRaven) {
                    const vehicleState = selectedRaven.vehicleState;
                    if (vehicleState && vehicleState.hasOwnProperty("ravenOffline")) {
                        this.setRavenOfflineState(vehicleState);
                    } else {
                        if (!this.vehicleStateLoading) {
                            this.vehicleStateLoading = true;
                            this.loadVehicleState(ravenUuid);
                        }
                    }    
                }    
            }
        }
    }

    setCards = cards => {

        if (this.componentIsMounted === false) return;

        if (!cards) {
            console.error('No cards found');
            return;
        }
        // append 'Z' to all timestamps bc kloud won't
        cards.forEach(card => {
            markTimestampUTC(card.start);
            markTimestampUTC(card.end);
        });
        this.setState({
            cards
        });
    }

    setRavenOfflineState = (vehicleState) => {
        if (vehicleState.hasOwnProperty("ravenOffline")) {
            this.setState({
                ravenOffline: vehicleState.ravenOffline
            });
        } else {
            console.warn("HistoryPage could not determine raven offline state, setting to false to avoid endless loop");
            this.setState({
                ravenOffline: false
            })
        }
    }

    loadCards = ravenUuid => {
        if(!ravenUuid) throw Error('loadCards: ravenUuid is required');

        const demo = this.props.user.original['custom:demo'];
        if(demo) {
            fetchDemoCards(demo, ravenUuid).then(cards => {
                this.setCards(cards);
            }).catch(err => {
                console.error('Failed to fetch demo cards', err);
                this.setState({ not_found: true });
            });
            return;
        }

        LambdaUtil.getRavenCards(this.props.user.stage, ravenUuid,
            data => {
                var raven = JSON.parse(data.Payload);
                if (raven && raven.status === 'ERROR') {
                    if(raven.errorCode === 1000)
                    {
                        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.sign_in_get_ravens_error), style: 'error', override: true } }));
                    }
                    else if(raven.errorCode === 4000)
                    {
                        this.setState({not_found: true});
                    }
                }
                this.setCards(raven && raven.raven && raven.raven.cards);
            },
            error => {
                console.error(error);
            }
        );
    }

    loadVehicleState = (ravenUuid) => {

        if (!ravenUuid) {
            this.vehicleStateLoading = false;
            return;
        }

        const demo = this.props.user.original['custom:demo'];
        if (demo) {
            const vehicleStateRavenOnline = {"vehicleState":{"currentPreviewUrls":[],"currentSpeed":0,"segId":0,"currentFuel":0,"ravenOffline":false,"currentCompassHeading":0,"heading":0}};
            this.setRavenOfflineState(vehicleStateRavenOnline);
            this.vehicleStateLoading = false;
            return;
        }
        LambdaUtil.getVehicleState(this.props.user.stage, ravenUuid, (response) => {

            this.vehicleStateLoading = false;

            if (!response || !response.Payload) {
                console.error("HistoryPage loadVehicleState received empty response");
                return;
            }
            const payloadParsed = JSON.parse(response.Payload);
            if (!payloadParsed) {
                console.error("HistoryPage loadVehicleState received invalid payload reponse");
                return;
            }
            console.log("HistoryPage request raven vehicleState");
            this.setRavenOfflineState(payloadParsed.vehicleState);
        }, (error) => {
            console.error(error);
        });
    }

    selectRaven = ravenUuid => {
        if (this.props.match.params.ravenUuid !== ravenUuid) {
            // triggers a componentDidUpdate which will set state accordingly
            this.setState({
                cards: null,
                requestedCardId: undefined,
                loadingNewCard: false, // cards are not loaded during raven switches
                card: null,
                selectedEvent: null,
                ravenOffline: undefined // "undefined" will trigger vehicleState check in subsequent componentDidUpdate
            });
            this.props.history.push(`/${getCurrentLocale()}/stats/history/${ravenUuid}`);
        }
    }

    selectCard = (cardId) => {
        const { ravenUuid } =  this.props.match.params;
        const cardSummary = this.state.cards ? this.state.cards.find(card => card.cardId === cardId) : null;
        this.setState({
            // IMPORTANT: need to update state to trigger History's map re-render
            // (else some sort of race condition leaves artifacts on map during card changes)
            card: cardSummary, // summary info can be used until details are populated
            loadingNewCard: true,
            selectedEvent: null // clear selected event to trigger default event select in finalizeCard()
        });

        const basePath = `/${getCurrentLocale()}/stats/history/${ravenUuid}`;
        const cardSpecifier = cardId ? `/${cardId}` : '';
        this.props.history.push(basePath + cardSpecifier);
    }

    // Card functions
    // Called when new driver assigned, new media, first-load, and switching cards
    loadDetailedCard = (ravenUuid, cardId) => {

        this.props.setMainModuleGroupDetailsTitle(strings.app_loading);

        this.setState({
            requestedCardId: cardId
        });

        const demo = this.props.user.original['custom:demo'];

        let fetchCardPromise;
        if(demo) {
            fetchCardPromise = fetchDemoCard(demo, ravenUuid, cardId);
        } else {
            fetchCardPromise = LambdaUtil.getCard(
                this.props.user.stage,
                ravenUuid,
                cardId,
            ).then(payload => {
                if(!payload.card) {
                    throw payload;
                }
                return payload.card;
            })
        }

        fetchCardPromise.then(card => {
            // send the lambda request
            card.media && this.props.dispatch(addAllMedia(
                ravenUuid,
                card.media.map(({ ts, url, statusTime, ...it }) => ({
                    ...it,
                    key: url,
                    timestamp: RavenUtil.toDate(ts),
                    statusTime: RavenUtil.toDate(statusTime),
                }))
            ));
            card.events && this.props.dispatch(addAllEventsAndLinkMedia(
                ravenUuid,
                card.events.map(({ts, media, ...it}) => ({
                    ...it,
                    mediaIds: media && media.mediaId ? [media.mediaId] : [],
                    timestamp: RavenUtil.toDate(ts)
                }))
            ));
            // unpack geofences and dispatch addGeofences action to redux
            card.geofences = card.geofences.map(geofences.unpack);
            this.props.dispatch(geofences.Actions.addGeofences(card.geofences));

            return card;
        }).then(card => {
            // Don't update the UI if this is not the card we're loading.
            // (e.g. user clicked a second card before the first finished
            // loading or we just want to update media in the background)
            if (card.cardId === this.state.requestedCardId) {
                this.finalizeCard(card);
            }
        }).catch(err => {
            console.error(err);
            this.setState({
                requestedCardId: undefined,
                loadingNewCard: false,
                cardError: err });
        });
    }

    selectEvent = (event) => {
        this.setState({ selectedEvent: event });
        if(event) {
            this.props.dispatch(requestImageUrlsForEventIfNeeded(this.props.match.params.ravenUuid, event.eventId));
        }
    }

    assignDriver = (identityId) => {
        const { ravenUuid, cardId } = this.props.match.params;
        return LambdaUtil.assignDriver(
            this.props.user.stage,
            ravenUuid,
            cardId,
            identityId
        ).then(() => {
            const { ravenUuid, cardId } = this.props.match.params;
            if(ravenUuid && cardId) {
                this.loadDetailedCard(ravenUuid, cardId);
            }
        });
    }

    setDriverName = (identityId, name) => {
        return LambdaUtil.setIdentityName(
            this.props.user.stage, 
            identityId, 
            name
        ).then(() => {
            const { ravenUuid, cardId } = this.props.match.params;
            if(ravenUuid && cardId) {
                this.loadDetailedCard(ravenUuid, cardId);
            }
        });
    }

    getCardVideoAvailabilityStartDate = (card) => { // based off of "PoC grade" similar function on line 843 of CardMap.js

        const historicalStreamingEnabled = this.props.features?.historical_streaming;

        if (!historicalStreamingEnabled) { // ie if FALSE
            return undefined;
        }
        
        const selectedRaven = this.getSelectedRaven();

        if(!selectedRaven?.canViewVideoStream) {
            return undefined;
        }

        if (this.state.ravenOffline) {
            return undefined;
        }

        if (!card) {
            console.warn("History CardDetailsPanel getCardVideoAvailabilityStartDate while card is not found");
            return undefined;
        }

        if (!card.events || card.events.length === 0) {
            console.warn("History CardDetailsPanel getCardVideoAvailabilityStartDate while card events are not found");
            return undefined;
        }

        // get date of earliest engine event with available media.
        // the earliest event will likely correspond to the card start date and serves as an acid test for card video availablility
        // check below is an attempt to optimize by avoiding full string compares etc to make the check as "tight" as possible
        // if no engine event with media, assume video not available for that card (workaround for inadequate video availability details)
        for (let i = card.events.length - 1; i >= 0; i -= 1) { // using basic for loop so we can break (in this case return true)
            if (!card.events[i].videoAvailable) continue;
            if (card.events[i].type.slice(8,14) ===  "GINE_O") { // sliced "EVENT_ENGINE_ON" / "EVENT_ENGINE_OFF" --> "GINE_O";
                if (card.events[i].videoAvailable.road) {
                    return RavenUtil.toDate(card.events[i].ts);
                }
                if (card.events[i].videoAvailable.road) {
                    return RavenUtil.toDate(card.events[i].ts);
                }
            }
        }
        return undefined;
    }

    finalizeCard(card) {
        if (card.type === "TRIP") {
            this.props.setMainModuleGroupDetailsTitle(strings.trip_report_heading);
        } else {
            this.props.setMainModuleGroupDetailsTitle(strings.parked_heading);
        }
        // console.log('finalizeCard', card.cardId);
        markTimestampUTC(card.start);
        markTimestampUTC(card.end);
        card.route.forEach(markTimestampUTC);
        card.events.forEach(markTimestampUTC);
        card.events.forEach(e => markTimestampUTC(e.geoStamp));
        card.drivers.forEach(driver => {
            if (driver && driver.startTime && !driver.startTime.endsWith('Z')) {
                driver.startTime = driver.startTime + 'Z';
            }
        })
        card.media.forEach(markTimestampUTC);
        card.segments && card.segments.forEach(
            segment => segment.speedZones && segment.speedZones.forEach(
                speedZone => markTimestampUTCForKeys(speedZone, ['startTime','endTime'])
            )
        );
        // console.log(card);

        card.route = RavenUtil.sortRoute(card.route);
        //place media items onto events so mediacarousel works as coded by grabbing media off of events.

        card.events = card.events.filter(document.filterEvent); // filter out unsupported events
        let clusterEventsKeyCounter = 0; // used for making unique reducerKeys for EVENT_KLOUD_HISTORICAL_STREAMING to avoid collapsing
        const mediaStreamingArchiveIds = card.media.filter(m => m.type === "MEDIA_STREAMING_ARCHIVE").map(m => m.mediaId);
        card.events = Object.values( // collapse events with multiple media (legacy card query)
            card.events.reduce((acc, { media, ...event }) => {
                const date = new Date(event.ts);
                const eventId = date.toISOString() + event.type;
                let reducerKey = eventId;
                let mediaItem;
                if (media) { // media items may be null (I observed a null media item from a EVENT_IDLING_STARTED event)
                    mediaItem = card.media.find(m => m.mediaId === media.mediaId);
                    if (event.type.substring(12) === "HISTORICAL_STREAMING") { // prevent this type of event's duplicates (w/ same timestamp) from being collapsed
                        if (mediaItem && mediaItem.type) {
                            if (mediaItem.type === "MEDIA_STREAMING_ARCHIVE") {
                                if (acc[reducerKey] &&
                                    acc[reducerKey].media.length > 0) {
                                    // check if acc[reducerKey].media already has a MEDIA_STREAMING_ARCHIVE
                                    let hasStreamingArchive = false;
                                    acc[reducerKey].media.forEach(m => {
                                        if (mediaStreamingArchiveIds.includes(m.mediaId)) {
                                            hasStreamingArchive = true;
                                        }
                                    });
                                    if (hasStreamingArchive) {
                                        clusterEventsKeyCounter += 1; // start a new cluster item
                                        reducerKey += clusterEventsKeyCounter; // treat as a unique event
                                    }
                                }
                            }
                        }
                    }
                } else {
                    mediaItem = media; // media is null
                }
                if (acc[reducerKey]) {
                    acc[reducerKey].media.push(mediaItem);
                } else {
                    acc[reducerKey] = { // clone the event with media as an array
                        ...event,
                        media: mediaItem && mediaItem.mediaId ? [mediaItem] : [],
                        date,
                        eventId
                    };
                }
                return acc;
            }, {})
        );

        card.events = card.events.map(event => { // transform eventParams from [{key:'key1', value:'value1'}] to {key1:'value1'}
            const { eventParams } = event;
            if (eventParams && eventParams.length) {
                return {
                    ...event,
                    eventParams: eventParams.reduce((acc, it) => {
                        acc[it.key] = it.value;
                        return acc;
                    }, {})
                };
            }
            return event;
        });
        card.events.sort((e1,e2) => e2.date - e1.date); // sort events chronologically
        RavenUtil.markParkedSegments(card.events);
        RavenUtil.mergeSpeedingEvents(card.events);
        RavenUtil.markHistoricalStreamingEventsClusters(card.events);
        RavenUtil.mergeIdlingEvents(card.events);
        // console.log('postsort', card.events);

        let selectedEvent = this.state.selectedEvent;
        if (!selectedEvent || selectedEvent.clustered) {
            // IMPORTANT: Since eventIds do not support clusters, we're forced to compare event obj references for clusters especially;
            // so selected clustered events need the updated reference (or indexes etc may be off if new events for card).
            // Attempts to update the selected clustered event in this component's state introduced weird crashes (race conditions while state+renders catch up)
            selectedEvent = card && card.events ? card.events[0] : null;
            this.selectEvent(selectedEvent);
        }
        if (selectedEvent) {
            // ensure new media items are available (if triggered by onRefreshMediaEvent(), this is required)
            this.props.dispatch(requestImageUrlsForEventIfNeeded(this.props.match.params.ravenUuid, selectedEvent.eventId));
        }
        this.setState({
            requestedCardId: undefined,
            loadingNewCard: false,
            card: card
        });
    }
    // END Card functions

    getSelectedRaven() {
        const { ravens, match } = this.props;
        if (!ravens) return null;
        return ravens.find(r => r.ravenUuid === match.params.ravenUuid);
    }

    render() {

        const { ravens, match, features } = this.props;
        const { cards, card } = this.state;
        const cardVideoAvailabilityStartDate = this.getCardVideoAvailabilityStartDate(card);

        let unitOfMeasure = DEFAULT_UOM;
        if (this.props.unitOfMeasure) {
            unitOfMeasure = this.props.unitOfMeasure.toUpperCase();
        }

        if (!ravens) return null;
        if (!features || typeof features.show_history === 'undefined') return null;
        if (!features.show_history) return <NotFoundPage {...this.props} />;
        if (!match.params.ravenUuid) return null;

        if (this.state.not_found) return <NotFoundPage {...this.props} />;

        const selectedRaven = this.getSelectedRaven();

        let sessionManagerSelectedResourceResourceType = HISTORY_SELECTED_RESOURCE_TYPES.HISTORY_CARD_PLACEHOLDER;
        if (card) {
            if (card.type === "TRIP") {
                sessionManagerSelectedResourceResourceType = HISTORY_SELECTED_RESOURCE_TYPES.HISTORY_CARD_DRIVING;
            } else {
                sessionManagerSelectedResourceResourceType = HISTORY_SELECTED_RESOURCE_TYPES.HISTORY_CARD_PARKED;
            }
        }

        const historicalStreamingEnabled = this.props.features?.historical_streaming;

        return (
            // className is 'dashboard-page and history-page' as stopgap measure to handle amalgamating event timeline components between dashboard and history
            <div className='dashboard-page history-page'>

                    <MainModuleGroup
                    
                        mainModuleGroupNavigation = {
                            <CardSelectPanel
                                raven={selectedRaven}
                                ravens={ravens}
                                match={match}
                                cards={cards}
                                selectedCardId={this.props.match.params.cardId}
                                selectRaven={this.selectRaven}
                                selectCard={this.selectCard}
                                unitOfMeasure={unitOfMeasure}
                            />
                        }

                        //mainModuleGroupNavigationTitle = {strings.history} // updated via Redux layoutTemplateModularFullscreen's setMainModuleGroupNavigationTitle()

                        mainModuleGroup = {
                            <CardMapPanel
                                card={card}
                                stage={this.props.user.stage}
                                vehicleName={selectedRaven && selectedRaven.vehicle ? selectedRaven.vehicle.name : ""}
                                theme={this.props.theme}
                                setLayoutFullscreen={this.props.setLayoutFullscreen}
                                loading={this.state.requestedCardId === undefined ? false : true}//loading={this.state.loadingNewCard}
                                mapCenterFallback={cards ? (cards[cards.length - 1] && cards[cards.length - 1].start) : false}
                                ravenUuid={this.props.match.params.ravenUuid}
                                ravenOffline={this.state.ravenOffline}
                                features={features}
                                selectedEvent={this.state.selectedEvent}
                                header={<CardHeader card={card} />}
                                onLiveStream={this.props.onLiveStream}
                                canViewVideoStream={selectedRaven?.canViewVideoStream}
                            />
                        }

                        // MainNavigation selected resource is menu-item-specifc and can differ from the user-selected resource
                        // This allows the MainNavigation selected item state to change without forcing the sessionManager's selectedResource to follow suit
                        // However, sessionManagerSelectedResourceResourceType can be provided to allow for special styling options
                        sessionManagerSelectedResourceResourceType={sessionManagerSelectedResourceResourceType}

                        enhancedVideoAccessModeActive={this.state.enhancedVideoAccessModeActive}

                        mainModuleGroupDetailsEVAPanel = {
                            historicalStreamingEnabled && selectedRaven?.canViewVideoStream && this.state.enhancedVideoAccessModeActive ?
                                <EnhancedVideoAccess
                                    toggleEnhancedVideoAccessModeActive = {this.toggleEnhancedVideoAccessModeActive}
                                    stage = {this.props.user.stage}
                                    mapUpdateKey = {this.props.mapUpdateKey} /* sync pureComponent props updates/renders with the map (dashboard, possibly also history) */
                                    ravenId = {selectedRaven.ravenUuid}
                                    cardId = {card ? card.cardId : undefined}
                                    selectedEvent = {this.state.selectedEvent}
                                    startGeostamp = {card ? card.start : undefined}
                                    endGeostamp = {card ? card.end : undefined}
                                    cardVideoAvailabilityStartDate = {cardVideoAvailabilityStartDate}
                                    route = {card ? card.route : undefined}
                                    events = {card ? card.events : undefined}
                                />
                            :
                                null
                        }

                        mainModuleGroupDetails = {
                            <CardDetailsPanel
                                user={this.props.user}
                                raven={selectedRaven}
                                ravenOffline={this.state.ravenOffline}
                                card={card}
                                cardVideoAvailabilityStartDate={cardVideoAvailabilityStartDate}
                                loading={this.state.loadingNewCard}
                                selectedEvent={this.state.selectedEvent}
                                onSelectEvent={this.selectEvent}
                                mqttService={this.props.mqttService}
                                features={features}
                                enhancedVideoAccessModeActive={this.state.enhancedVideoAccessModeActive}
                                toggleEnhancedVideoAccessModeActive={this.toggleEnhancedVideoAccessModeActive}
                                assignDriver={this.assignDriver}
                                setDriverName={this.setDriverName}
                                unitOfMeasure={unitOfMeasure}
                            />
                        }

                        //mainModuleGroupDetailsTitle = {strings.action_details} // updated via Redux layoutTemplateModularFullscreen's setMainModuleGroupDetailsTitle()
                    />

            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {        
        tags: tagsSelectors.tags(state),
        tagsLoaded: tagsSelectors.loaded(state),
        settingsLoaded: SettingsSelectors.settingsLoaded(state),
        unitOfMeasure: SettingsSelectors.unitOfMeasure(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadSettings: () => dispatch(loadSettings(ownProps.user && ownProps.user.stage)),
        setMainNavigationActiveMenuItemId: (activeMenuItemId) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainNavigationActiveMenuItemId(activeMenuItemId));
            return;
        },
        setMainModuleGroupDetailsTitle: (title) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupDetailsTitle(title));
            return;
        },
        setLayoutFullscreen: (fullscreenModeIsActive) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setFullscreenMode(fullscreenModeIsActive));
            return;
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryPage);
